export const MIN_CHANNEL_BUDGET = 50;
export const ROUNDING_TOLERANCE = 1;
